import React from 'react'
import { Provider } from 'react-redux';
import { store } from '../stores';
import { Toaster } from 'react-hot-toast';
import { DndProvider, getBackendOptions, MultiBackend } from '@minoru/react-dnd-treeview';

interface ProvidersProps {
    children: React.ReactNode
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
    return (
        <Provider store={store}>
            <DndProvider backend={MultiBackend} options={getBackendOptions()}>
                    <Toaster 
                        containerClassName='custom-toast'
                    />
                {children}
            </DndProvider>
        </Provider>
    )
}